import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\layout\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\layout\\Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\layout\\ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\layout\\SkipToMainContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\ReCaptchaProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProvider"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\context\\ConsentContext.tsx");
